module.exports = fox._r("images/twistys.png", __webpack_public_path__ + "images/twistys.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/twistys.png
// module id = 1134
// module chunks = 4